export function cache5Mins() {
    return Date.now() + 5 * 60 * 1000;
}

export const CACHE_10_MINS = 1000 * 60 * 10;
export const CACHE_30_MINS = 1000 * 60 * 60;
